export type Vec3 = [number, number, number];

export interface MeshData {
  /** Współrzędne wierzchołków: 3 liczby na wierzchołek. */
  positions: Float32Array;
  /** Indeksy trójkątów: 3 indeksy na trójkąt. */
  indices: Uint32Array;
}

export interface Bounds {
  min: Vec3;
  max: Vec3;
  size: Vec3;
  diagonal: number;
}

export interface MeshStats {
  vertices: number;
  triangles: number;
  edges: number;
  openEdges: number;
  boundaryLoops: number;
  nonManifoldEdges: number;
  inconsistentEdges: number;
  duplicateFaces: number;
  degenerateFaces: number;
  shells: number;
  volume: number;
  area: number;
  bounds: Bounds;
  closed: boolean;
  watertight: boolean;
}

export interface RepairOptions {
  /** Tolerancja scalania wierzchołków w mm; <= 0 oznacza automatyczną. */
  tolerance: number;
  weld: boolean;
  removeDegenerate: boolean;
  removeDuplicates: boolean;
  fixWinding: boolean;
  fillHoles: boolean;
  /** Maksymalna liczba krawędzi dziury do wypełnienia; 0 = bez limitu. */
  maxHoleEdges: number;
  keepLargestShell: boolean;
}

export interface RepairReport {
  before: MeshStats;
  after: MeshStats;
  tolerance: number;
  weldedVertices: number;
  removedDegenerate: number;
  removedDuplicates: number;
  flippedFaces: number;
  filledHoles: number;
  filledTriangles: number;
  skippedHoles: number;
  removedShells: number;
  removedShellFaces: number;
  openLoopsLeft: number;
  ms: number;
}

export interface EdgeSegment {
  a: Vec3;
  b: Vec3;
}

/** Wewnętrzny opis krawędzi topologii (a < b, znormalizowany kierunek). */
export interface EdgeInfo {
  a: number;
  b: number;
  count: number;
  /** Suma kierunków: +1 gdy (a -> b), -1 gdy (b -> a), 0 dla niezgodnych. */
  dir: number;
  f1: number;
  f2: number;
  extra: number[] | null;
}

export interface RepairResult {
  mesh: MeshData;
  report: RepairReport;
  openEdges: EdgeSegment[];
  nonManifoldEdges: EdgeSegment[];
}

export interface ParsedStl {
  mesh: MeshData;
  format: 'binary' | 'ascii';
}

export function defaultRepairOptions(): RepairOptions {
  return {
    tolerance: 0,
    weld: true,
    removeDegenerate: true,
    removeDuplicates: true,
    fixWinding: true,
    fillHoles: true,
    maxHoleEdges: 0,
    keepLargestShell: false,
  };
}
